import React, { useState, useEffect } from "react";
import { APIURL } from "../Config";
import axios from "axios";

function EmployerDetails({ corpid }) {
  const token = localStorage.getItem("token");
  const [empData, setEmpData] = useState([]);
  const [isLoader, setIsLoader] = useState(false);

  useEffect(() => {
    getEmployerDetails(corpid);
  }, []);
  console.log("corp id::", corpid);
  const getEmployerDetails = (corporateid) => {
    setIsLoader(true);
    axios
      .request(`${APIURL}/employerdetails/${corporateid}`, {
        method: "GET",
        headers: {
          Authentication: token,
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        setEmpData(response?.data);
        setIsLoader(false);
        console.log("response::::", response);
      })
      .catch((error) => {
        console.log(error);
        setIsLoader(false);
      });
  };
  return (
    <>
      <div className="mt-3">
        <div className="pt-1" style={{ backgroundColor: "#a6df6d" }}>
          <h5 className="text-center">Profile</h5>
        </div>
        {isLoader ? (
          <div className="d-flex justify-content-center">
            <div className="spinner-border text-success" role="status">
              <span className="sr-only">Loading...</span>
            </div>
          </div>
        ) : (
          <div className="row">
            <div
              className="col-lg-5 col-md-5 col-sm-12 d-flex mt-5"
              style={{ justifyContent: "center" }}
            >
              <img
                src={
                  empData?.url ||
                  "https://cdn.vectorstock.com/i/500p/53/42/user-member-avatar-face-profile-icon-vector-22965342.jpg"
                }
                alt="Client"
                style={{
                  objectFit: "contain",
                  width: "250px",
                  height: "250px",
                }}
              />
            </div>
            <div
              className="col-lg-7 col-md-7 col-sm-12"
              style={{ fontSize: "14px" }}
            >
              <div className="row mt-4">
                <b className="col-4 col-xs-6">Company Name</b>
                <p className="col-8 col-xs-6 mb-1" style={{ fontSize: "16px" }}>
                  {empData?.companyName}
                </p>
              </div>
              <div className="row">
                <b className="col-4 col-xs-6">Emp Name </b>
                <p className="col-8 col-xs-6 mb-1" style={{ fontSize: "16px" }}>
                  {empData?.empname}
                </p>
              </div>
              <div className="row ">
                <b className="col-4 col-xs-6">Work Email </b>
                <p className="col-8 col-xs-6 mb-1" style={{ fontSize: "16px" }}>
                  {empData?.email}
                </p>
              </div>
              <div className="row">
                <b className="col-4 col-xs-6">Mobile No.</b>
                <p className="col-8 col-xs-6 mb-1" style={{ fontSize: "16px" }}>
                  {empData?.mobile}
                </p>
              </div>
              <div className="row">
                <b className="col-4 col-xs-6">No. of Employees</b>
                <p className="col-8 col-xs-6 mb-1" style={{ fontSize: "16px" }}>
                  {empData?.numberofemployees}
                </p>
              </div>
              <div className="row">
                <b className="col-4 col-xs-6">Address</b>
                <p className="col-8 col-xs-6 mb-1" style={{ fontSize: "16px" }}>
                  {empData?.address}
                </p>
              </div>

              <div className="row">
                <b className="col-4 col-xs-6">Model</b>
                <p className="col-8 col-xs-6 mb-1" style={{ fontSize: "16px" }}>
                  {empData?.model}
                </p>
              </div>

              <div className="row">
                <b className="col-4 col-xs-6">Company type</b>
                <p className="col-8 col-xs-6 mb-1" style={{ fontSize: "16px" }}>
                  {empData?.companyType}
                </p>
              </div>
              <div className="row">
                <b className="col-4 col-xs-6">Fund employees</b>
                <p className="col-8 col-xs-6 mb-1" style={{ fontSize: "16px" }}>
                  {empData?.fundEmployees}
                </p>
              </div>
              <div className="row">
                <b className="col-4 col-xs-6">HR App</b>
                <p className="col-8 col-xs-6 mb-1" style={{ fontSize: "16px" }}>
                  {empData?.hrApp}
                </p>
              </div>

              <div className="row">
                <b className="col-4 col-xs-6">Code</b>
                <p className="col-8 col-xs-6 mb-1" style={{ fontSize: "16px" }}>
                  {empData?.code}
                </p>
              </div>

              <div className="row">
                <b className="col-4 col-xs-6">Status</b>
                <p className="col-8 col-xs-6 mb-1" style={{ fontSize: "16px" }}>
                  {empData?.status}
                </p>
              </div>

              <div className="row">
                <b className="col-4 col-xs-6">Set up fees</b>
                <p className="col-8 col-xs-6 mb-1" style={{ fontSize: "16px" }}>
                  ₹{empData?.setupfees}
                </p>
              </div>
              <div className="row">
                <b className="col-4 col-xs-6">Convenience fees</b>
                <p className="col-8 col-xs-6 mb-1" style={{ fontSize: "16px" }}>
                  {empData?.commercialfees}%
                </p>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
}

export default EmployerDetails;
